import $ from '../_snowpack/pkg/jquery.js';
import L from '../_snowpack/pkg/leaflet.js';

const Neignborhood = {
  map: null,
  mobileToggle: false,
  polygons: [],
  callback: null,
  defaultColors: { lineColor: '#06C5FF', fillColor: '#06C5FF' },
  neigh: [],
  open: async function(callback) {
    $('.neighborhood').fadeIn();
    this.callback = callback;
    if (this.polygons.length) {//runs every time except first time map has been clicked
      setTimeout(() => this.map.invalidateSize(), 0);
      if(window.innerWidth<700){
				$('.bt-minus').click();
			}
    } else {//runs first time map icon is clicked
      const response = await this.get();
      this.neigh = response;
      this.setList(response.sort((a, b) => a.name.localeCompare(b.name)));
      this.initMap(response);
			if(window.innerWidth<700){
				$('.bt-minus').click();
			}
    }
    window.xxxx=0;
    $(document).on('click', '.list-neighborhood', function(e) {
    	e.stopImmediatePropagation();
  		console.log(xxxx);xxxx++;
  		if( $('.list-neighborhood i').hasClass('bt-ulist')){
    		$('.list-neighborhood i').removeClass('bt-ulist').addClass('bt-map');

  		} else {
			  $('.list-neighborhood i').removeClass('bt-map').addClass('bt-ulist');
  		}

  		$('#neighborhood-map').toggle(this.mobileToggle);
  		$('.neighborhood-list').toggle(!this.mobileToggle);
      //const btnClass = this.mobileToggle ? 'bt-ulist' : 'bt-map';

      //$('.list-neighborhood i').removeClass('bt-ulist').removeClass('bt-map').addClass(btnClass);
      if (this.mobileToggle) setTimeout(() => window.map.invalidateSize(), 0);
      this.mobileToggle = !this.mobileToggle;
      //e.stopImmediatePropagation();
    });
    $('.neighborhood-list div').on('click', function() {
			if(window.innerWidth<700){
				$('.bt-minus').click();
			}
    });
  },
  get: async function() {
   return await fetch('https://hipster.io/api/neighborhood?filter=geoCity%7C%7C$eq%7C%7C30').then(response => response.json());
  },
  setList: function(n) {
    $('.neighborhood-list').html('<div></div>')
    n.forEach((ele, index) => {
      const div = $('<div>').text(ele.name)
          .on('click', this.close.bind(this, ele))
          .on('mouseover', this.onListMouseOver.bind(this, index))
          .on('mouseout', this.onListMouseOut.bind(this, index, ele));
      $('.neighborhood-list > div').append(div)
    });
  },
  initMap(neighborhoods, callback) {
    this.map = L.map('neighborhood-map', {
      center: [38.9072, -77.0369],//hardcoded, need to pull from database
      attributionControl: false,
      maxZoom: 16,
      minZoom: 12,
      zoom: 13,
      layers: [
        L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png'),
        L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}.png')
      ]
    });

    setTimeout(() => this.map.invalidateSize(), 500);

    neighborhoods.forEach((item, index) => {
      this.polygons.push(L.polygon(item.points, {
        color: item.lineColor,
        fillColor: item.fillColor,
        fillOpacity: 0.6,
      }).on('click', () =>
        this.close(item)
      ).on('mouseover', () => {
        this.setPolygonColor(this.defaultColors, index).bringToFront();
      }).on('mouseout', () => {
        this.setPolygonColor(item, index);
      }).bindTooltip(item.name,
        { permanent: true, direction: 'center', opacity: 0.6, className: 'neighborhood-tooltip' }
      ).openTooltip().addTo(this.map));
    });
  },
  onListMouseOver(index) {
    this.setPolygonColor(this.defaultColors, index).bringToFront();
  },
  onListMouseOut(index, item) {
    this.setPolygonColor(item, index);
  },
  setPolygonColor(color, index) {
    return this.polygons[index].setStyle({
      color: color.lineColor,
      fillColor: color.fillColor
    });
  },
  close(item) {
    this.callback(item);

		if( $('.list-neighborhood i').hasClass('bt-ulist')){
  		var donothing=1;
		} else {
			$('.list-neighborhood').click();
		}

    $('.neighborhood').fadeOut();
  },
  getByName: async function(name) {
    if (!this.neigh.length) this.neigh = await this.get();
    return this.neigh.find((o) => o.name === name);
  }
};

export default Neignborhood;
